import $ from "jquery";

import * as splitTest from "splitTest";

export const install = () => {
  const link = $('link[rel="chrome-webstore-item"]');
  if (link.length > 0) {
    splitTest.trackEvent("chromeExtension-startInstall");
    window.chrome.webstore.install(
      link.attr("href"),
      () => {
        splitTest.trackEvent("chromeExtension-finishInstall", () => {
          window.location.href = "/links";
        });
      },
      () => {
        // Install failed
      }
    );
  }
};
